import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/collapse.svg';
const Collapse = () => React.createElement(IconSvg, null);
export default Collapse;
